import PhoneNumberField from 'components/consumer/checkout/desktop/components/Shipping/components/PhoneNumberField';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Radio from 'components/essentials/Radio';

const CustomerContactOption = ({ onChange }) => {
  const [contactOption, setContactOption] = useState('email');
  const [phoneNumber, setPhoneNumber] = useState('');

  const handlePhoneNumberChange = e => {
    const newPhoneNumber = e.target.value;
    setPhoneNumber(newPhoneNumber);
    onChange({ phone: newPhoneNumber });
  };

  return (
    <div className="CustomerContactOption mt-4">
      <p className="font-bold text-base mb-2">
        How would you like us to contact you?
      </p>

      <div className="flex flex-row items-center gap-3">
        <Radio
          name="contact-option"
          checked={contactOption === 'email'}
          onChange={() => {
            onChange(null);
            setContactOption('email');
          }}
        >
          Email
        </Radio>

        <Radio
          name="contact-option"
          checked={contactOption === 'phone'}
          onChange={() => {
            setContactOption('phone');
            onChange({ phone: phoneNumber });
          }}
        >
          Phone
        </Radio>
      </div>

      {contactOption === 'phone' && (
        <PhoneNumberField
          value={phoneNumber}
          handleChange={handlePhoneNumberChange}
          handleBlur={handlePhoneNumberChange}
          placeholder="Phone number"
        />
      )}
    </div>
  );
};

CustomerContactOption.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default CustomerContactOption;
